import { FormEvent } from "react";
import { PasswordRule } from "../../types/admin";
import { PasswordRuleList } from "./PasswordRuleList";
import { TranslationKey } from "../../../shared/i18n/i18n";
import { TurnstileWidget } from "./TurnstileWidget";

type SignUpFormProps = {
  acceptedTerms: boolean;
  email: string;
  isSubmitDisabled: boolean;
  isSubmitting: boolean;
  onAcceptedTermsChange: (checked: boolean) => void;
  onEmailChange: (value: string) => void;
  onOpenSignIn: () => void;
  onOpenTermsOfUse: () => void;
  onPasswordChange: (value: string) => void;
  onReceiveUpdatesChange: (checked: boolean) => void;
  onSubmit: (event: FormEvent) => Promise<void>;
  password: string;
  passwordPattern: string;
  passwordRequirements: string;
  receiveProductUpdates: boolean;
  rules: PasswordRule[];
  turnstileResetKey: number;
  turnstileSiteKey: string;
  turnstileToken: string;
  onTurnstileTokenChange: (value: string) => void;
  t: (key: TranslationKey) => string;
};

export const SignUpForm = (props: SignUpFormProps) => {
  const {
    acceptedTerms,
    email,
    isSubmitDisabled,
    isSubmitting,
    onAcceptedTermsChange,
    onEmailChange,
    onOpenSignIn,
    onOpenTermsOfUse,
    onPasswordChange,
    onReceiveUpdatesChange,
    onSubmit,
    password,
    passwordPattern,
    passwordRequirements,
    receiveProductUpdates,
    rules,
    turnstileResetKey,
    turnstileSiteKey,
    turnstileToken,
    onTurnstileTokenChange,
    t,
  } = props;
  return (
    <form
      autoComplete="off"
      className="auth-form"
      onSubmit={(event) => void onSubmit(event)}
    >
      <label className="field">
        <span>{t("admin.field.email")}</span>
        <input
          onChange={(event) => onEmailChange(event.target.value)}
          required
          type="email"
          value={email}
        />
      </label>
      <label className="field">
        <span>{t("admin.field.password")}</span>
        <input
          minLength={15}
          onChange={(event) => onPasswordChange(event.target.value)}
          pattern={passwordPattern}
          required
          title={passwordRequirements}
          type="password"
          value={password}
        />
      </label>
      <PasswordRuleList rules={rules} />
      <label className="checkbox-field">
        <input
          checked={acceptedTerms}
          onChange={(event) => onAcceptedTermsChange(event.target.checked)}
          required
          type="checkbox"
        />
        <span>
          {t("admin.terms.prefix")}{" "}
          <button
            className="inline-link-anchor"
            onClick={onOpenTermsOfUse}
            type="button"
          >
            {t("admin.terms.linkLabel")}
          </button>
        </span>
      </label>
      <label className="checkbox-field">
        <input
          checked={receiveProductUpdates}
          onChange={(event) => onReceiveUpdatesChange(event.target.checked)}
          type="checkbox"
        />
        <span>{t("admin.field.receiveProductUpdates")}</span>
      </label>
      <TurnstileWidget
        onTokenChange={onTurnstileTokenChange}
        resetKey={turnstileResetKey}
        siteKey={turnstileSiteKey}
        token={turnstileToken}
      />
      <button
        className="primary-button"
        disabled={isSubmitDisabled}
        type="submit"
      >
        {isSubmitting ? t("admin.auth.button.creatingAccount") : t("admin.auth.button.createAccount")}
      </button>
      <p className="switch-line">
        {t("admin.auth.switch.haveAccount")}{" "}
        <button
          className="link-button inline-link"
          onClick={onOpenSignIn}
          type="button"
        >
          {t("admin.mode.signIn")}
        </button>
      </p>
    </form>
  );
};
